function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 26.287c0-14.36 11.64-26 26-26s26 11.64 26 26c0 14.359-11.64 26-26 26s-26-11.641-26-26z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#trophy_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26 51.375C12.144 51.375.911 40.143.911 26.287.912 12.432 12.145 1.199 26 1.199c13.855 0 25.088 11.232 25.088 25.088 0 13.856-11.232 25.088-25.088 25.088zM26 .287c-14.358 0-26 11.64-26 26s11.64 26 26 26 26-11.64 26-26c0-14.359-11.642-26-26-26z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26 49.094c-12.596 0-22.807-10.21-22.807-22.806S13.405 3.48 26 3.48c12.597 0 22.807 10.212 22.807 22.808S38.597 49.094 26 49.094zM26 1.2C12.145 1.199.912 12.43.912 26.287S12.145 51.374 26 51.374c13.856 0 25.088-11.232 25.088-25.087S39.856 1.199 26 1.199",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26 3.48C13.403 3.48 3.192 13.69 3.192 26.287c0 12.597 10.212 22.807 22.807 22.807 12.597 0 22.807-10.21 22.807-22.807C48.806 13.69 38.596 3.48 26 3.48z",
  fill: "#FBAD00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.317 12.419a.903.903 0 01.907-.905h18.148a.909.909 0 01.908.905c0 .974-.022 1.9-.062 2.78a5.454 5.454 0 013.578 2.253 5.421 5.421 0 01.059 6.12 5.437 5.437 0 01-3.535 2.32 5.46 5.46 0 01-2.158-.034c-1.434 3.375-3.408 5.025-5.142 5.448v3.933l2.587.644c.352.087.684.244.974.461l3.336 2.496a.905.905 0 01-.545 1.629H17.224a.909.909 0 01-.86-.619.902.902 0 01.316-1.01l3.336-2.496c.29-.217.622-.374.974-.461l2.586-.644v-3.933c-1.733-.423-3.707-2.073-5.141-5.45a5.46 5.46 0 01-4.165-.767 5.437 5.437 0 01-2.354-3.51 5.415 5.415 0 01.881-4.131 5.436 5.436 0 013.584-2.251 59.7 59.7 0 01-.064-2.778zm.18 4.596a3.63 3.63 0 00-2.334 1.504 3.611 3.611 0 00.924 5.035c.792.546 1.77.755 2.716.583-.604-1.9-1.067-4.246-1.306-7.122zm18.298 7.122a3.638 3.638 0 002.716-.583 3.611 3.611 0 00.924-5.035 3.63 3.63 0 00-2.333-1.504c-.241 2.878-.704 5.221-1.307 7.122z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.527 22.768l1.768-1.064 1.769 1.078-.464-2.015 1.558-1.344-2.049-.182-.814-1.903-.814 1.89-2.049.181 1.558 1.358-.463 2zm-1.698 2.337l.912-3.933-3.06-2.645 4.043-.35 1.571-3.708 1.572 3.708 4.042.35-3.06 2.645.913 3.933-3.467-2.085-3.466 2.085z",
  fill: "#FBAD00"
}));

function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 53",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "trophy_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 53
  }, _ref), _ref2);
}

export default SvgTrophy;